var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShape08(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 522 509",
    width: 522,
    height: 509,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M276.087 28.053S419.496-5.44 410.991 187.484c-6.593 149.529 117.423 78.019 90.069 184.581-27.354 106.563-314.419 171.515-397.083-17.066C2.125 122.643 276.087 28.053 276.087 28.053Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F84FF",
    d: "M164.742 374.851C74.096 350.563 20.302 257.389 44.591 166.743 68.88 76.096 162.053 22.303 252.7 46.591 343.346 70.88 397.14 164.053 372.851 254.7c-24.289 90.646-117.462 144.44-208.109 120.151Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape08);
export default __webpack_public_path__ + "static/media/shape08.eb03ee0357170f43f58f602f09c0d43e.svg";
export { ForwardRef as ReactComponent };